<template>
    <v-row>
        <v-col cols="">
            <v-card></v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {

}
</script>

<style>

</style>